//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React from "react";
import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer";
import * as moment from "moment";
import { useTranslation } from 'react-i18next';
// Create styles
const styles = StyleSheet.create({
  body: {
    padding: 10,
  },
  table1: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  table2: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    marginBottom: 10,
  },
  table3: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: {
    margin: "auto",
    flexDirection: "row",
  },
  table1ColHeader: {
    backgroundColor: "#315496",
    color: "#ffffff",
    width: "100%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  table2ColHeader: {
    backgroundColor: "#ffffff",
    color: "#000",
    width: "16.66%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  table2Col: {
    width: "16.66%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableColHeader: {
    backgroundColor: "#315496",
    color: "#ffffff",
    width: "11.11%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCol: {
    width: "11.11%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  table1CellHeader: {
    margin: "auto",
    margin: 5,
    fontSize: 12,
    fontWeight: 500,
    textAlign: "center",
  },
  tableCellHeader: {
    margin: "auto",
    margin: 5,
    fontSize: 12,
    fontWeight: 500,
  },
  tableCell: {
    margin: "auto",
    margin: 5,
    fontSize: 7,
  },
});

// Create Document Component
export default function MemberLevelRewardPDF({ states, date, setStates }) {
  const { pdfData } = states;
  let transactions = pdfData?.transactionHistory;
  const { t, i18n} = useTranslation()
  return (
    <Document
      onRender={() => {
        document.getElementById("download-pdf").click();
      }}
    >
      <Page style={styles.body}>
        <View style={styles.table1}>
          <View style={styles.tableRow}>
            <View style={styles.table1ColHeader}>
              <Text style={styles.table1CellHeader}>
                {t("Transactions Summary from")} {date}
              </Text>
            </View>
          </View>
        </View>
        <View style={styles.table2}>
          <View style={styles.tableRow}>
            <View style={styles.table2ColHeader}>
              <Text style={styles.tableCellHeader}>{t('Report Date')}</Text>
            </View>
            <View style={styles.table2ColHeader}>
              <Text style={styles.tableCellHeader}>{t('Loyalty ID')}</Text>
            </View>
            <View style={styles.table2ColHeader}>
              <Text style={styles.tableCellHeader}>
                Ending {"           "}Balance
              </Text>
            </View>
            <View style={styles.table2ColHeader}>
              <Text style={styles.tableCellHeader}>
                Points Earned/{"  "}Adjusted
              </Text>
            </View>
            <View style={styles.table2ColHeader}>
              <Text style={styles.tableCellHeader}>
                Points {"                "}Redeemed
              </Text>
            </View>
            <View style={styles.table2ColHeader}>
              <Text style={styles.tableCellHeader}>
                Points {"                "}Expired
              </Text>
            </View>
          </View>
          <View style={styles.tableRow}>
            <View style={styles.table2Col}>
              <Text style={styles.tableCell}>
                {moment().format("MM/DD/YYYY")}
              </Text>
            </View>
            <View style={styles.table2Col}>
              <Text style={styles.tableCell}>{pdfData?.loyaltyId}</Text>
            </View>
            <View style={styles.table2Col}>
              <Text style={styles.tableCell}>{pdfData?.currentBalance}</Text>
            </View>
            <View style={styles.table2Col}>
              <Text style={styles.tableCell}>{pdfData?.pointsEarned}</Text>
            </View>
            <View style={styles.table2Col}>
              <Text style={styles.tableCell}>{pdfData?.pointsRedeemed}</Text>
            </View>
            <View style={styles.table2Col}>
              <Text style={styles.tableCell}>{pdfData?.pointsExpired}</Text>
            </View>
          </View>
        </View>

        <View style={styles.table3}>
          <View style={styles.tableRow}>
            <View style={styles.tableColHeader}>
              <Text style={styles.tableCellHeader}>{t('Transaction Date')}</Text>
            </View>
            <View style={styles.tableColHeader}>
              <Text style={styles.tableCellHeader}>{t('Order Id')}</Text>
            </View>
            <View style={styles.tableColHeader}>
              <Text style={styles.tableCellHeader}>{t('Product Description')}</Text>
            </View>
            <View style={styles.tableColHeader}>
              <Text style={styles.tableCellHeader}>{t('Location Num')}</Text>
            </View>
            <View style={styles.tableColHeader}>
              <Text style={styles.tableCellHeader}>{t('Business')}</Text>
            </View>
            <View style={styles.tableColHeader}>
              <Text style={styles.tableCellHeader}>{t('Transaction Type')}</Text>
            </View>
            <View style={styles.tableColHeader}>
              <Text style={styles.tableCellHeader}>{t('Description')}</Text>
            </View>
            <View style={styles.tableColHeader}>
              <Text style={styles.tableCellHeader}>{t('Expiration Date')}</Text>
            </View>
            <View style={styles.tableColHeader}>
              <Text style={styles.tableCellHeader}>{t('Points')}</Text>
            </View>
          </View>
          {transactions?.map((t, i) => (
            <View style={styles.tableRow} key={i}>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{t?.transaction_date}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{t?.order_id}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{t?.product_short_description}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{t?.location_number}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{t?.business}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{t?.transaction_type}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{t?.description}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{t?.expiration_date}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{t?.points}</Text>
              </View>
            </View>
          ))}
        </View>
      </Page>
    </Document>
  );
}

// export default MyDocument;
